import React from 'react';
import { Link } from 'react-router-dom';
import { SeenIcon } from '@/components/common/SeenLogo';
import { AlertTriangle } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-900 text-white">
      {/* Health Disclaimer Banner */}
      <div className="bg-amber-500 text-amber-950 py-3 px-4">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm text-center">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <p>
            <strong>Health Disclaimer:</strong> This app provides informational analysis only and is NOT a substitute for 
            reading labels yourself or professional medical advice. Always verify ingredients if you have allergies.
          </p>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <SeenIcon size={32} />
              <span className="font-bold text-[#5DBDB3]">SEEN</span>
            </div>
            <p className="text-slate-400 text-sm">
              See beyond the label. Know what you&apos;re eating.
            </p>
            <p className="text-slate-500 text-xs mt-4">
              Seen Beyond the Label Ltd<br />
              Registered in England & Wales
            </p>
          </div>
          
          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4 text-slate-200">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/auth" className="text-slate-400 hover:text-white transition-colors">
                  Get Started
                </Link>
              </li>
              <li>
                <Link to="/subscription" className="text-slate-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-slate-200">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4 text-slate-200">Contact</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <a href="mailto:support@seenbeyondthelabel.co.uk" className="hover:text-white transition-colors">
                  support@seenbeyondthelabel.co.uk
                </a>
              </li>
              <li>
                <a href="mailto:legal@seenbeyondthelabel.co.uk" className="hover:text-white transition-colors">
                  legal@seenbeyondthelabel.co.uk
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              &copy; {currentYear} Seen Beyond the Label Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-slate-500">
              <Link to="/terms" className="hover:text-slate-300 transition-colors">Terms</Link>
              <span>•</span>
              <Link to="/privacy" className="hover:text-slate-300 transition-colors">Privacy</Link>
              <span>•</span>
              <span>Made in the UK 🇬🇧</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
